<template>
<div>

<div class="columns is-gapless colBorder">


<div class="column is-4">
<div class="columns is-gapless is-multiline">

<div class="column is-8"> 
<div class="columns is-gapless is-multiline">
    <div @click="impot_show_payments()" class="column isLink is-12 is-size-4 has-text-weight-bold">&nbsp;{{data.student_lNAME}}
        <span class="is-pulled-right is-size-7">{{data.student_GRPCODE}}&nbsp;</span>
    </div>
    <div class="column is-4 is-size-6" style="margin-top:-.5em;">&nbsp;{{data.student_fNAME}}</div>
    <div class="column is-4 is-size-6" style="margin-top:-.5em;">&nbsp;{{data.student_CodePerm}}</div>
    <div class="column is-4 is-size-6 has-text-right" style="margin-top:-.5em;">&nbsp;{{data.student_NumAdmission}}</div>


<div class="column is-12 mt-2 has-text-centered">{{data.student_CreateDate | moment("add", "1 days","MMM DD YY")}} - {{data.student_EndDate | moment("add", "1 days","MMM DD YY")}}  </div>


</div>
</div>

<div class="column is-3">  <!-- PAIEMENTS  -->
    <div class="columns is-gapless is-multiline">
        <div class="column is-6 is-size-7 has-background-warning-light has-text-right colBorder">{{format_money(data.student_frais_owe,'$')}}&nbsp;</div>
        <div class="column is-6 is-size-7 has-background-success-light has-text-right colBorder">{{format_money(data.student_frais_pay,'$')}}&nbsp;</div>
        <div class="column is-12 is-size-5 has-text-centered colBorderRight" :class="return_style_solde(data.student_frais_solde)">{{format_money(data.student_frais_solde,'$')}}</div>

<div class="column mt-3 is-8 is-size-7 has-text-centered" :class="isSIN(data.student_SIN)" style="margin-top:-.5em;">{{data.student_SIN}}</div>
<div class="column is-4 has-text-centered colBorderRight"><span v-if="+data.student_blnComplete" class="icon mt-2 has-text-dark"><i class="fas fa-user-graduate"></i></span>&nbsp;</div>


    </div>
</div>


</div></div>




<!-- <div class="column is-1 colBorder">
<div class="columns is-gapless is-multiline">
    <div class="column is-12 has-text-weight-bold">&nbsp;{{data.student_lNAME}}</div>
    <div class="column is-12 is-size-7" style="margin-top:-.5em;">&nbsp;{{data.student_fNAME}}&nbsp;{{data.student_ID}}</div>
</div></div> -->


<!-- <div class="column is-1  mt-2  has-text-centered is-size-7 has-text-weight-bold">
<div class="columns is-gapless is-multiline">
    <div class="column is-12">&nbsp;{{data.student_CreateDate | moment("add", "1 days","MMM-DD-YY")}}</div>
    <div class="column is-12">&nbsp;{{data.student_EndDate | moment("add", "1 days","MMM-DD-YY")}}
        <span v-if="+data.student_blnComplete" class="icon is-pulled-right has-text-success"><i class="fas fa-user-graduate"></i></span>
    </div>
</div></div>

<div class="column is-1 colBorder">
<div class="columns is-gapless is-multiline">
    <div class="column is-12 has-text-centered">{{data.student_GRPCODE}}</div>
    <div class="column is-12 is-size-7 has-text-centered" :class="isSIN(data.student_SIN)" style="margin-top:-.5em;">{{data.student_SIN}}</div>
</div></div>

<div class="column is-1">
<div class="columns is-gapless is-multiline">
    <div class="column is-6 is-size-7 has-background-warning-light has-text-right colBorder">{{format_money(data.student_frais_owe,'$')}}&nbsp;</div>
    <div class="column is-6 is-size-7 has-background-success-light has-text-right colBorder">{{format_money(data.student_frais_pay,'$')}}&nbsp;</div>
    <div class="column is-12 is-size-5 has-text-centered colBorderRight" :class="return_style_solde(data.student_frais_solde)">{{format_money(data.student_frais_solde,'$')}}</div>
</div></div> -->

<!-- PAI TOTAL FOR YEAR  -->
<div class="column is-1 is-size-5 has-text-right mt-4 mb-3 has-background-light box is-marginless">
<div class="columns is-gapless is-multiline">
    <div class="column is-12">{{format_money(data.amt,'$')}}&nbsp;</div>
    <div class="column is-12 is-size-6">{{data.hrs_total}} Hrs&nbsp;</div>
</div></div>

<div class="column is-2 ">
<div class="columns is-gapless is-centered is-multiline">
    <div class="column is-7 is-size-7 has-text-right mt-2">Amount for Studies (A) &nbsp;&nbsp;</div>
    <div class="column is-3 has-text-centered"><input :disabled="check_enabled(0)" v-model="impot_qc_amt" class="input has-text-right is-small has-text-weight-bold" placeholder=""> </div>

    <div class="column is-7 is-size-7 has-text-right mt-2">Tuition or exam fees (B) &nbsp;&nbsp;</div>
    <div class="column is-3 has-text-centered"><input :disabled="check_enabled(0)" class="input has-text-right is-small has-text-weight-bold" placeholder=""></div>

    <div class="column is-7 is-size-7 has-text-right mt-2">Donations (C) &nbsp;&nbsp;</div>
    <div class="column is-3 has-text-centered"><input :disabled="check_enabled(0)" class="input has-text-right is-small has-text-weight-bold" placeholder=""></div>

</div></div>

<div class="column is-4">
<div class="columns is-gapless is-centered is-multiline">
<div class="column is-3 colBorderRight">
<div class="columns is-gapless is-multiline has-background-light">
    <div class="column is-4 has-text-centered mt-2 is-size-7 has-text-weight-bold">{{data.hrs_can_1}}</div>
    <div class="column is-4 has-text-centered"> <input :disabled="check_enabled(this.data.hrs_can_1)" v-model="splCan_1[0]" class="input has-text-centered is-small has-text-weight-bold" :class="return_style_box_impot(data.hrs_can_1)" placeholder=""> </div>
    <div class="column is-4 has-text-centered"> <input :disabled="check_enabled(this.data.hrs_can_1)" v-model="splCan_1[1]" class="input has-text-centered is-small has-text-weight-bold" :class="return_style_box_impot(data.hrs_can_1)" placeholder=""> </div>
    <div class="column is-6 has-text-centered"> <input :disabled="check_enabled(this.data.hrs_can_1)" v-model="splCan_1[2]" class="input has-text-centered is-small has-text-weight-bold" :class="return_style_box_impot(data.hrs_can_1)" placeholder=""> </div>
    <div class="column is-6 has-text-centered"> <input :disabled="check_enabled(this.data.hrs_can_1)" v-model="splCan_1[3]" class="input has-text-centered is-small has-text-weight-bold" :class="return_style_box_impot(data.hrs_can_1)" placeholder=""> </div>
    <div class="column is-12 has-text-centered"> <input :disabled="check_enabled(this.data.hrs_can_1)" v-model="splCan_1[4]" class="input has-text-right is-small has-text-weight-bold" :class="return_style_box_impot(data.hrs_can_1)" placeholder=""> </div>
</div></div>
<!-- END CAN 1 -->

<div class="column is-3 colBorderRight has-background-light">
<div class="columns is-gapless is-multiline">
    <div class="column is-4 has-text-centered mt-2 is-size-7 has-text-weight-bold">{{data.hrs_can_2}}</div>
    <div class="column is-4 has-text-centered"> <input :disabled="check_enabled(this.data.hrs_can_2)" v-model="splCan_2[0]" class="input has-text-centered is-small has-text-weight-bold" :class="return_style_box_impot(data.hrs_can_2)" placeholder=""> </div>
    <div class="column is-4 has-text-centered"> <input :disabled="check_enabled(this.data.hrs_can_2)" v-model="splCan_2[1]" class="input has-text-centered is-small has-text-weight-bold" :class="return_style_box_impot(data.hrs_can_2)" placeholder=""> </div>
    <div class="column is-6 has-text-centered"> <input :disabled="check_enabled(this.data.hrs_can_2)" v-model="splCan_2[2]" class="input has-text-centered is-small has-text-weight-bold" :class="return_style_box_impot(data.hrs_can_2)" placeholder=""> </div>
    <div class="column is-6 has-text-centered"> <input :disabled="check_enabled(this.data.hrs_can_2)" v-model="splCan_2[3]" class="input has-text-centered is-small has-text-weight-bold" :class="return_style_box_impot(data.hrs_can_2)" placeholder=""> </div>
    <div class="column is-12 has-text-centered"> <input :disabled="check_enabled(this.data.hrs_can_2)" v-model="splCan_2[4]" class="input has-text-right is-small has-text-weight-bold" :class="return_style_box_impot(data.hrs_can_2)" placeholder=""> </div>
</div></div>
<!-- END CAN 2 -->

<div class="column is-3 colBorderRight">
<div class="columns is-gapless is-multiline has-background-light">
    <div class="column is-4 has-text-centered mt-2 is-size-7 has-text-weight-bold">{{data.hrs_can_3}}</div>
    <div class="column is-4 has-text-centered"> <input :disabled="check_enabled(this.data.hrs_can_3)" v-model="splCan_3[0]" class="input  has-text-centered is-small has-text-weight-bold" :class="return_style_box_impot(data.hrs_can_3)" placeholder=""> </div>
    <div class="column is-4 has-text-centered"> <input :disabled="check_enabled(this.data.hrs_can_3)" v-model="splCan_3[1]" class="input has-text-centered is-small has-text-weight-bold" :class="return_style_box_impot(data.hrs_can_3)" placeholder=""> </div>
    <div class="column is-6 has-text-centered"> <input :disabled="check_enabled(this.data.hrs_can_3)" v-model="splCan_3[2]" class="input has-text-centered is-small has-text-weight-bold" :class="return_style_box_impot(data.hrs_can_3)" placeholder=""> </div>
    <div class="column is-6 has-text-centered"> <input :disabled="check_enabled(this.data.hrs_can_3)" v-model="splCan_3[3]" class="input has-text-centered is-small has-text-weight-bold" :class="return_style_box_impot(data.hrs_can_3)" placeholder=""> </div>
    <div class="column is-12 has-text-centered"> <input :disabled="check_enabled(this.data.hrs_can_3)" v-model="splCan_3[4]" class="input has-text-right is-small has-text-weight-bold" :class="return_style_box_impot(data.hrs_can_3)" placeholder=""> </div>
</div></div>
<!-- END CAN 3 -->

</div></div>
<!-- END CANADA BOXES  -->


<!-- <div class="column is-1 colBorderRight"></div> -->
<!-- <div class="columns is-gapless is-multiline has-background-light">
    <div class="column is-4 has-text-centered mt-2 is-size-7 has-text-weight-bold">{{data.hrs_can_4}}</div>
    <div class="column is-4 has-text-centered"> <input v-model="splCan_4[0]" class="input has-text-centered is-small has-text-weight-bold" placeholder=""> </div>
    <div class="column is-4 has-text-centered"> <input v-model="splCan_4[1]" class="input has-text-centered is-small has-text-weight-bold" placeholder=""> </div>
    <div class="column is-6 has-text-centered"> <input v-model="splCan_4[2]" class="input has-text-centered is-small has-text-weight-bold" placeholder=""> </div>
    <div class="column is-6 has-text-centered"> <input v-model="splCan_4[3]" class="input has-text-centered is-small has-text-weight-bold" placeholder=""> </div>
    <div class="column is-12 has-text-centered"> <input @keyup="is_changed=true" v-model="splCan_4[4]" class="input has-text-right is-small has-text-weight-bold" placeholder=""> </div>
</div> -->
<!-- END CAN 4 -->

<div v-if="is_changed" class="column is-1 mt-4">
    <button @click="impot_save()" class="button is-large is-fullwidth has-background-success has-text-white">
        <span class="icon is-small"> <i class="fas fa-save"></i> </span>&nbsp;&nbsp;
    </button>
</div>
<div v-else-if="is_selected" class="column is-1 mt-5 has-text-centered">
    <button @click="impot_unlock()" class="button has-background-warning has-text-dark">
        <span class="icon is-small"> <i class="fas fa-unlock"></i> </span>
    </button>
</div>
<div v-else class="column is-1 mt-4">
    <button @click="impot_lock()" class="button is-fullwidth has-background-info has-text-white">
        <span class="icon is-small"> <i class="fas fa-calendar-alt"></i> </span>&nbsp;&nbsp;SEL.
    </button>
</div>


</div> <!-- END COLUMN  -->

</div>
</template>

<script>
import axios from 'axios';
import moment from 'moment';

export default {
        props: [ 'data' , 'data_tax' , 'impot_year'],
        components: {  },

        data() {
            return {

                is_changed:false,
                is_selected:false,

              
                impot_qc_amt:'',
                impot_qc_fees:'',
                impot_qc_dons:'',

                splCan_1:[],
                splCan_2:[],
                splCan_3:[],
                splCan_4:[],

qString:'',

            }
        },


mounted () {

    if (this.data_tax.length>0) {
        // HERE - HAS ENTRY ALREADY !

// SELECTED
this.is_selected= +this.data_tax[0].studTax_SELECTED;

        this.impot_qc_amt = this.data_tax[0].studTax_QC_AMT
        this.splCan_1 = this.data_tax[0].studTax_CAN_1.split('|');
        this.splCan_2 = this.data_tax[0].studTax_CAN_2.split('|');
        this.splCan_3 = this.data_tax[0].studTax_CAN_3.split('|');
        this.splCan_4 = this.data_tax[0].studTax_CAN_4.split('|');

    } else {

        // CHECK QC AMOUNT
        if (this.data.hrs_total == 0) {this.impot_qc_amt = 0} else if (this.data.hrs_total >= 180) {this.impot_qc_amt = 5966} else {this.impot_qc_amt = 2938}
  
// SELECTED
this.is_selected=false;  

var paiCount = 0; // HOW MUCH TO DIVIDE BY
var pai_1 = false // WHAT TO UPDATE
var pai_2 = false
var pai_3 = false

var sTax = '' // CAN 1
        if (this.data.hrs_can_1 > 0) {
paiCount++ ; pai_1 = true
            if (this.data.hrs_can_1 < 200) {sTax+="4|0|01|04|0000|"} else {sTax+="0|4|01|04|0000|"}
            this.splCan_1 = sTax.split('|');
        } else {
           this.splCan_1 = ("|||||").split('|'); 
           this.data.hrs_can_1 = "-"
        }

sTax = '' // CAN 2
        if (this.data.hrs_can_2 > 0) {
paiCount++ ; pai_2 = true
            if (this.data.hrs_can_2 < 200) {sTax+="4|0|05|08|0000|"} else {sTax+="0|4|05|08|0000|"}
            this.splCan_2 = sTax.split('|');
        } else {
           this.splCan_2 = ("|||||").split('|'); 
           this.data.hrs_can_2 = "-"
        }

sTax = '' // CAN 3
        if (this.data.hrs_can_3 > 0) {
paiCount++ ; pai_3 = true
            if (this.data.hrs_can_3 < 200) {sTax+="4|0|09|12|0000|"} else {sTax+="0|4|09|12|0000|"}
            this.splCan_3 = sTax.split('|');
        } else {
           this.splCan_3 = ("|||||").split('|'); 
           this.data.hrs_can_3 = "-"
        }

sTax = '' // CAN 4
        if (this.data.hrs_can_4 > 0) {
            if (this.data.hrs_can_4 < 200) {sTax+="-|-|-|-|-|"} else {sTax+="-|-|-|-|-|"}
            this.splCan_4 = sTax.split('|');
        } else {
           this.splCan_4 = ("|||||").split('|'); 
           this.data.hrs_can_4 = "-"
        }


// NEED TO SORT PAIEMENTS !!!!
if (paiCount > 0) {
    var amt = (Number(this.data.amt) / Number(paiCount)).toFixed(2)
    if (pai_1) {this.splCan_1[4] = amt}
    if (pai_2) {this.splCan_2[4] = amt}
    if (pai_3) {this.splCan_3[4] = amt}
}



    } // END IF

}, // END MOUNTED



methods : {

impot_show_payments:function() {
    this.$emit('emit_impot_show_payments', this.data.student_ID)

},


impot_save:function(lock) {
// INSERT ONLY

// NEED TO DO SOME CHECKING


if (lock) {this.is_selected = true;}

var totCan = 0 
if (Number(this.splCan_1[4])>0) {totCan = +parseFloat(totCan) + +parseFloat(this.splCan_1[4]).toFixed(2)}
if (Number(this.splCan_2[4])>0) {totCan = +parseFloat(totCan) +  +parseFloat(this.splCan_2[4]).toFixed(2)}
if (Number(this.splCan_3[4])>0) {totCan = +parseFloat(totCan) +  +parseFloat(this.splCan_3[4]).toFixed(2)}
if (Number(this.splCan_4[4])>0) {totCan = +parseFloat(totCan) +  +parseFloat(this.splCan_4[4]).toFixed(2)}

// var totCan = this.chk_num_return(this.splCan_1[4]) + this.chk_num_return(this.splCan_2[4]) + this.chk_num_return(this.splCan_3[4]) 
// alert(totCan)

var sCan1 = this.splCan_1[0] + "|" + this.splCan_1[1] + "|" + this.splCan_1[2] + "|" + this.splCan_1[3] + "|" + this.splCan_1[4] + "|" 
var sCan2 = this.splCan_2[0] + "|" + this.splCan_2[1] + "|" + this.splCan_2[2] + "|" + this.splCan_2[3] + "|" + this.splCan_2[4] + "|" 
var sCan3 = this.splCan_3[0] + "|" + this.splCan_3[1] + "|" + this.splCan_3[2] + "|" + this.splCan_3[3] + "|" + this.splCan_3[4] + "|" 

var query= `INSERT INTO [myMEQ_STUDENT_TAX]([student_ID],[studTax_YEAR],[studTax_SELECTED],[studTax_HRS],[studTax_QC_AMT],[studTax_QC_FEES],[studTax_QC_DONS],[studTax_CAN_1],[studTax_CAN_2],[studTax_CAN_3], studTax_CAN_AMT) VALUES (` + this.data.student_ID + `,` + this.impot_year + `,` + +this.is_selected + `,` + this.data.hrs_total + `,` + this.chk_num(this.impot_qc_amt) + `,` + this.chk_num(this.impot_qc_fees) + `,` + this.chk_num(this.impot_qc_dons) + `,'` + sCan1 + `','` + sCan2 + `','` + sCan3 + `',` + totCan + `);`

    // this.qString += query
   

    axios.get(this.$url+sessionStorage.getItem('url_query')+'?query=' + encodeURIComponent(query))
    .then(res => {
        this.$snotify.success('Saved !!', {timeout: 2000,showProgressBar: true,closeOnClick: false,pauseOnHover: true}); 
        this.$emit("emit_impot_change", "ADD",this.impot_qc_amt,parseFloat(totCan))
    });


},

chk_num:function(val){
    if (Number(val) > 0) {return parseFloat(val).toFixed(2)} else {return 'NULL'} 
},
chk_num_return:function(val){
    if (Number(val) > 0) {return parseFloat(val).toFixed(2)} else {return 0} 
},

impot_unlock:function() {
// DELETE FROM TABLE !!  INSERT ONLY 
    var query = "DELETE FROM myMEQ_STUDENT_TAX WHERE student_ID = " + this.data.student_ID
    axios.get(this.$url+sessionStorage.getItem('url_query')+'?query=' + encodeURIComponent(query))
    .then(res => {
        this.is_selected = false;
        this.$emit("emit_impot_change", "DEL",this.impot_qc_amt,parseFloat(this.data.amt).toFixed(2))
    });
}, // END UNLOCK

impot_lock:function() {
    this.impot_save(true)
}, // END LOCK


check_enabled:function(val) {
// CHECK IF CAN CHANGE ----
    if (+this.is_selected) {return true}
    else {return isNaN(val)}
},


// CHECK IF BALANCE !!!!
return_style_solde:function(amt) {
    if (+amt<=0) {return ''}
    else {return 'has-background-danger-light'}
},

// CHECK IF HAS HOURS FOR BOX hl? !!!!
return_style_box_impot:function(hrs) {
    if (hrs > 0 ) {return 'is-warning'}
    else {return 'is-grey'}
},


// CHECK SOCIAL INSURANCE NUMBER !!!!
isSIN:function(sSIN) {
    var sinner = sSIN.replace(/[^A-Z0-9]/ig, "")

    if (this.validateSIN(sinner)) {return 'blur-it-up'}
    else {return 'has-background-danger'}
},


validateSIN:function(sin) {

  var check, even, tot;
  if (typeof sin === 'number') {sin = sin.toString();}

  if (sin.length === 9) {
    // convert to an array & pop off the check digit
    sin = sin.split('');
    check = +sin.pop();
    even = sin
      .filter(function (_, i) { return i % 2; })
      .map(function (n) { return n * 2; })
      .join('').split('');
        tot = sin
      .filter(function (_, i) { return !(i % 2); })
      .concat(even)
      .map(function (n) { return +n; })
      .reduce(function (acc, cur) { return acc + cur; });
    return check === (10 - (tot % 10)) % 10;
  } else return false;
},




format_money:function (n, currency) {
    try {return currency + parseFloat(n).toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,");}
    catch(err) {return '-' }
},


}, // END METHODS


}
</script>

<style scoped>

.blur-it-up {
  font-size: 4em;
  text-align: center;
  color: transparent;
  text-shadow: #111 0 0 15px;
  transition: 0.4s;
  font-family: HelveticaNeue;
}

</style>